import React, { useState } from "react";
import { Container, Typography, Grid, Box, Chip, Stack } from "@mui/material";
import Route from "../Route/Route";
import Loading from "../Utilities/Loading/Loading";
import BusAlertIcon from "@mui/icons-material/BusAlert";
import TuneIcon from "@mui/icons-material/Tune";

function Routes({
  setView,
  setItem,
  allBusses,
  loading,
  title,
  seatSelect,
  hasSearched,
  pickup,
  drop,
  date,
}) {
  const [selectedBus, setSelectedBus] = useState([]);
  const formattedDate = date && typeof date.format === "function" ? date.format("YYYY-MM-DD") : date;

  return (
    <Box id="route-results" sx={{ bgcolor: "#F0F4F8", minHeight: "50vh", py: 7, scrollMarginTop: "96px" }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: 5 }}>
          <Typography variant="h4" fontWeight={800} color="#0D1B2A" gutterBottom>
            {title}
          </Typography>
          <Box
            sx={{
              width: 56,
              height: 4,
              borderRadius: 2,
              background: "linear-gradient(90deg, #1565C0, #0288D1)",
              mx: "auto",
            }}
          />
        </Box>

        {hasSearched && (
          <Box
            sx={{
              mb: 4,
              p: { xs: 2, md: 2.5 },
              borderRadius: 3,
              background: "linear-gradient(135deg, rgba(21,101,192,0.08) 0%, rgba(2,136,209,0.12) 100%)",
              border: "1px solid rgba(21,101,192,0.12)",
            }}
          >
            <Stack
              direction={{ xs: "column", md: "row" }}
              spacing={1.5}
              justifyContent="space-between"
              alignItems={{ xs: "flex-start", md: "center" }}
            >
              <Box>
                <Typography variant="overline" sx={{ color: "#1565C0", fontWeight: 800, letterSpacing: 1.2 }}>
                  Live Search Result
                </Typography>
                <Typography variant="h6" fontWeight={800} color="#0D1B2A">
                  {allBusses.length > 0
                    ? `${allBusses.length} bus${allBusses.length > 1 ? "es" : ""} found for your trip`
                    : "No buses found for this search"}
                </Typography>
              </Box>

              <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                {pickup && <Chip icon={<TuneIcon />} label={`From: ${pickup}`} sx={{ bgcolor: "white" }} />}
                {drop && <Chip label={`To: ${drop}`} sx={{ bgcolor: "white" }} />}
                {formattedDate && <Chip label={`Date: ${formattedDate}`} sx={{ bgcolor: "white" }} />}
              </Stack>
            </Stack>
          </Box>
        )}

        {loading ? (
          <Loading />
        ) : allBusses.length === 0 ? (
          <Box sx={{ textAlign: "center", py: 10 }}>
            <BusAlertIcon sx={{ fontSize: 80, color: "#B0BEC5", mb: 2 }} />
            <Typography variant="h6" color="text.secondary" fontWeight={600}>
              No buses available for this route
            </Typography>
            <Typography variant="body2" color="text.disabled" mt={1}>
              Try a different date or destination
            </Typography>
          </Box>
        ) : (
          <Grid container spacing={2.5}>
            {allBusses.map((bus, index) => (
              <Grid item xs={12} key={bus.id}>
                <Route
                  containStep={false}
                  item={bus}
                  index={index}
                  selectBus={() => {}}
                  setView={setView}
                  setItem={setItem}
                  seatSelect={seatSelect}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </Box>
  );
}

export default Routes;
